import styled from 'styled-components'
import { theme } from "../theme";

const Container = styled.div`
  height: 120px;
  width: 100px;
  border-radius: 5px;
  border: 1px solid rgba(0,0,0,0.1);
  margin-right: ${theme.spacing.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    transform: scale(1.05);
    box-shadow: -10px 20px 40px -10px rgba(0,0,0,0.2);
  }
`

const Name = styled.div`
  padding-top: ${theme.spacing.xs};
  font-weight: bold;
  text-align: center;
  font-size: ${theme.typography.textSizes.xs};
`

interface Props {
  title: string | React.ReactElement;
  icon: React.ReactElement;
}

export function LinkBox(props: Props) {

  return (
    <Container>
      {props.icon}
      <Name>{props.title}</Name>
    </Container>
  )
}